export const languages = [
    'en',
    'kh'
];